import { FC } from 'react'
import { ValidationResults } from '../../../address-scheduler/ValidationResultsPage/ValidationResults'

export const AddressValidationResults: FC = () => {
  return (
    <ValidationResults
      title={'Address Confirmation'}
      instructions={'Consider using a suggested address to help our agents request dispatch to the right place in an emergency.'}
    />
  )
}
